import React from 'react'
import BaseComponent from './BaseContainer'
import {graphql, compose, withApollo} from 'react-apollo'
import {Redirect} from 'react-router'
import SubjectForm from '../components/form/Subject'
import getSubject from '../apollo/graphql/subject/get'
import getSubjects from '../apollo/graphql/subject/getSubjects'
import getMainSubjects from '../apollo/graphql/subject/getMainSubjects'
import getLanguages from '../apollo/graphql/getLanguages'
import updateSubject from '../apollo/graphql/subject/update'
import createSubject from '../apollo/graphql/subject/create'
import deleteSubject from '../apollo/graphql/subject/delete'
import {convertGraphQlToObject, convertObjetToGraphQlVariables} from '../helpers/contentWithI18n'
import {languages} from '../constants'
import { createTranslationsObject } from '../helpers/translation'

class SubjectContainer extends BaseComponent {

  constructor (props) {
    super(props)

    const isNew = props.match.params.objId === 'new' || props.match.params.objId === undefined

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: {
        email: null,
        parent_id: null,
        translations: createTranslationsObject({
          title: '',
          label: ''
        })
      },
      languages: []
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client.query({
        query: getSubject,
        variables: { id: this.props.match.params.objId }
      }).then(({ data }) => {
        let newState

        if (data.getSubject === null) {
          newState = {
            status: {
              ...this.state.status,
              isNew: true
            }
          }
        } else {
          const newObject = {...this.state.obj, ...convertGraphQlToObject(data.getSubject)}
          newState = {
            ...this.state,
            status: {
              ...this.state.status,
              loading: false
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations
              }
            }
          }
        }

        newState.status.loading = false

        this.setState(newState)
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      })
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false
        }
      })
    }
  }

  handleChange (event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj
      }
    }

    let dataIsLanguage = false

    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true
      }
    }

    if (dataIsLanguage) {
      // translations data
      newState.obj.translations[data][event.target.id] = event.target.value
    } else if (type === 'dropdown') {
      // dropdown
      newState.obj[data.id] = data.value
    } else {
      // simple data
      newState.obj[event.target.id] = event.target.value
    }

    this.setState(newState)
  }

  handleSubmit (event) {
    event.preventDefault()

    this.setState({
      status: {
        ...this.state.status,
        loading: true
      }
    })

    let obj = convertObjetToGraphQlVariables(this.state.obj)

    if (this.state.status.isNew) {
      this.props.createSubject({
        variables: {
          ...obj
        }
      }).then((data) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: `Création effectuée le ${new Date(Date.now()).toLocaleString()}`,
            isNew: false
          },
          obj: convertGraphQlToObject(data.data.createSubject),
          redirect: true
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: true
          }
        })
      })
    } else {
      this.props.updateSubject({
        variables: {
          id: this.state.obj.id,
          ...obj
        }
      }).then((data) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: `Mise à jour effectuée le ${new Date(Date.now()).toLocaleString()}`,
            isNew: false
          },
          obj: convertGraphQlToObject(data.data.updateSubject),
          redirect: true
        })
      }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true,
            isNew: false
          }
        })
      })
    }
  }

  handleDelete (event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deleteSubject({ variables: { id: this.state.obj.id } }).then(
        this.props.history.push('/contact/subjects')
      ).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to='/contact/subjects'/>
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>
    }

    return <SubjectForm
      obj={this.state.obj}
      status={this.state.status}
      subjects={this.props.subjects}
      languages={this.props.languages}
      onChange={this.handleChange}
      onSubmit={this.handleSubmit}
      onDelete={this.handleDelete}/>
  }
}

const SubjectContainerEnhanced = compose(
  graphql(getMainSubjects, { name: 'subjects' }),
  graphql(getLanguages, { name: 'languages' }),
  graphql(updateSubject, { name: 'updateSubject' }),
  graphql(createSubject, { name: 'createSubject' }),
  graphql(deleteSubject, {
    name: 'deleteSubject',
    options: {
      update: (proxy, { data }) => {
        const subjects = proxy.readQuery({ query: getSubjects })
        subjects.getSubjects = subjects.getSubjects.filter(obj => obj.id !== data.deleteSubject.id)
        proxy.writeQuery({ query: getSubjects, data: subjects })
      }
    }
  })
)(SubjectContainer)

export default withApollo(SubjectContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/SubjectContainer.js